export default __webpack_public_path__ + "static/media/pause.cc121409.svg";